import {
	ContractStatus,
	ContractStatusValues,
	PropositionProductTypeValues,
} from "@dune/types";
import { Tabs, TabsList, TabsTriggerWithNumber } from "@dune/ui";
import React from "react";
import { getPropositionStatusLabel } from "@dune/utils";
import { ProductTypeTabsSection } from "../../../component/common/ProductTypeTabsSection";
import { useProductTypeTabs } from "../../../component/common/useProductTypeTabs";

interface ContractFiltersProps {
	productTypeFilter: PropositionProductTypeValues | undefined;
	onProductTypeFilterChange: (
		productType: PropositionProductTypeValues | undefined,
	) => void;
	statusFilter: ContractStatusValues | undefined;
	onStatusFilterChange: (status: ContractStatusValues | undefined) => void;
	productTypeCounts: Record<string, number>;
	statusCounts: Record<string, number>;
	searchInput: string;
	onSearchChange: (value: string) => void;
}

export const ContractFilters: React.FC<ContractFiltersProps> = ({
	productTypeFilter,
	onProductTypeFilterChange,
	statusFilter,
	onStatusFilterChange,
	productTypeCounts,
	statusCounts,
	searchInput,
	onSearchChange,
}) => {
	const { productTypeTabs, shouldShowProductTypeTabs } =
		useProductTypeTabs(productTypeCounts);

	const contractStatusTabs = [
		{
			value: undefined,
			label: "Tous",
			count: statusCounts.all || 0,
		},
		{
			value: ContractStatus.CONTRACT_ONGOING,
			label: getPropositionStatusLabel(ContractStatus.CONTRACT_ONGOING),
			count: statusCounts[ContractStatus.CONTRACT_ONGOING] || 0,
		},
		{
			value: ContractStatus.CONTRACT_WARRANTY,
			label: getPropositionStatusLabel(ContractStatus.CONTRACT_WARRANTY),
			count: statusCounts[ContractStatus.CONTRACT_WARRANTY] || 0,
		},
		{
			value: ContractStatus.CONTRACT_TERMINATED,
			label: getPropositionStatusLabel(ContractStatus.CONTRACT_TERMINATED),
			count: statusCounts[ContractStatus.CONTRACT_TERMINATED] || 0,
		},
	];

	return (
		<div className="space-y-4">
			{/* Contract Status Tabs - Classic style */}
			<Tabs
				value={statusFilter || "all"}
				onValueChange={(value) =>
					onStatusFilterChange(
						value === "all" ? undefined : (value as ContractStatusValues),
					)
				}
			>
				<TabsList>
					{contractStatusTabs.map((tab) => (
						<TabsTriggerWithNumber
							key={tab.value || "all"}
							value={tab.value || "all"}
							variant="compact"
							number={tab.count}
						>
							{tab.label}
						</TabsTriggerWithNumber>
					))}
				</TabsList>
			</Tabs>

			<ProductTypeTabsSection
				productTypeTabs={productTypeTabs}
				productTypeFilter={productTypeFilter}
				onProductTypeFilterChange={onProductTypeFilterChange}
				searchInput={searchInput}
				onSearchChange={onSearchChange}
				searchPlaceholder="Rechercher par référence, numéro de contrat, assureur..."
				shouldShow={shouldShowProductTypeTabs}
			/>
		</div>
	);
};
